import { Stack } from '@mui/material';
import {
  InstallationPlanCard,
  InstallationGeneralDetailCard,
  InstallationProductCard,
  InstallationDecisionCard,
  InstallationDeliveryCard
} from 'modules/components/layer20';

import React from 'react';



export type ProjectInstallationDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectInstallationDetailSectionProps) => {

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      columnGap='1.5rem'
    >
      {/* LEFT */}
      <Stack
        direction='column'
        rowGap='1.25rem'
        flex='1 1 0'
      >
        <InstallationGeneralDetailCard.FC />
        <InstallationDecisionCard.FC />
        <InstallationPlanCard.FC />
      </Stack>

      {/* RIGHT */}
      <Stack
        flex='1 1 0'
        direction='column'
        rowGap='1.25rem'
      >
        <InstallationProductCard.FC />
        <InstallationDeliveryCard.FC />
      </Stack>


    </Stack>
  );
};
